<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C14.93,0,14.87,0.03,14.81,0.04C14.81,0.04,14.81,0.02,14.81,0.02C14.81,0.02,4.81,2.02,4.81,2.02C4.81,2.02,4.81,2.04,4.81,2.04C4.35,2.13,4,2.52,4,3C4,3,4,12.12,4,12.12C3.69,12.05,3.35,12,3,12C1.34,12,0,12.9,0,14C0,15.1,1.34,16,3,16C4.66,16,6,15.1,6,14C6,14,6,6.32,6,6.32C6,6.32,14,4.72,14,4.72C14,4.72,14,10.12,14,10.12C13.69,10.05,13.35,10,13,10C11.34,10,10,10.9,10,12C10,13.1,11.34,14,13,14C14.66,14,16,13.1,16,12C16,12,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Music',
} as DefineComponent
</script>
